import { createFileRoute } from '@tanstack/react-router'
import { NewsletterPage } from '../components/pages'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/newsletter')({
  head: () => staticRouteHead('newsletter', 'it'),
  component: NewsletterPage,
})
